<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-10">
            <div class="d-flex">
                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="">Enit</a></li>
                    <li class="active"> <a routerLink="/enit/eTrade/loadalgoapproval" aria-current="page">Algo Approval</a></li>
                    
                </ul>
            </div>

        </div>
    </div>
    <div>

        <form >
            <fieldset >
                <div class="card card-body col-lg-12 mt-3 ">

                    <h6>
                        Algo Approval
                    </h6>
                    <div class="row">
                        <div class="col-lg-3 form-group">
                            <label>Member Code :<span class="red">*</span></label>
                            <input type="text" class="form-control"  >
                        </div>  
                        <div class="col-lg-3 form-group">
                            <label>Sebi Registration No :<span class="red">*</span></label>
                            <input type="text" class="form-control"  >
                        </div>  
                        <div class="col-lg-3 form-group">
                            <label>Member Code :<span class="red">*</span></label>
                            <input type="text" class="form-control"  >
                        </div>  
                        <div class="col-lg-3 form-group">
                            <label>Application Type :<span class="red">*</span></label>
                            <select class="form-control "  title="Select Place"
                            data-style="btn-info">
                            <option selected disabled value=""> Select Title</option>
                            <option selected value="1">New </option>
                            <option selected value="1">Modification</option></select>
                        </div>  
                    </div>
                    <div class="row">
                        <div class="col-lg-3 form-group">
                            <label>No of Application(s) :<span class="red">*</span></label>
                            <select class="form-control "  title="Select Place"
                            data-style="btn-info">
                            <option selected disabled value=""> Select Title</option>
                            <option selected value="1">Single</option>
                            <option selected value="1">Multiple</option></select>
                        </div>  

                        <div class="col-lg-3 form-group">
                            <label>Co-location :<span class="red">*</span></label>
                            <select class="form-control "  title="Select Place"
                            data-style="btn-info">
                            <option selected disabled value=""> Select Title</option>
                            <option selected value="1">Colo</option>
                            <option selected value="1">NonColo</option>
                            <option selected value="1">Both</option></select>
                        </div>  
                    
                       
                    </div>
                    <div class="row">
                        
                    </div>
                    <div class="row">
                        
                        
                    </div>
                    <div class="row">
                       
                    </div>
                    <div class=" form-group">
                        <p> <input type="checkbox" formControlName="CheckType" > 
                            I/We declare to abide by the rules/regulations as communicated by the Exchange/SEBI/other Regulators from time to time.
                        </p>
                    </div>
                    <div class="row justify-content-start mb-5">
                        <div class="col-lg-8">
                            <div class="row justify-content-start">
                                <div class="col-lg-2">
                                    <button class="btn  btn-primary full-width" type="reset">Reset</button>
                                </div>
                                <div class="col-lg-2">
                                    <button class="btn btn-primary full-width"   type="submit" >Submit</button>
                                </div>
                                <div class="col-lg-2">
                                    <button class="btn btn-primary full-width" type="button">Certify</button>
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
                   
                
            </fieldset>
        </form>
    </div>

</div>